// Base Page Mixin with common behaviour
// for all static pages
var MpStaticPage = {

    data: function() {
        return {
            isInitialized: false,
        };
    },

    methods: {

        init: function() {
            if (this.isInitialized) {
                return;
            }

            this.isInitialized = true;
        },
    },

    filters: {},

    created: function () {},

    mounted: function() {
        this.init();
    },

    updated: function() {
        if (!this.isInitialized) {
            this.init();
        }
    }
};
